<div class="rounded-lg p-6 shadow-sm border bg-blue-50 border-blue-200">
  <div class="flex mb-4">
    <h2 class="text-lg font-semibold">
      {{ question.question }}<span *ngIf="question.is_required" class="text-red-500"> *</span>
    </h2>
  </div>
  <div class="space-y-4 px-10">
    <div class="quiz-option flex items-start" *ngFor="let answer of question.answers">
      <div class="relative flex items-start justify-start">
        <input
          type="radio"
          name="choice-with-opinion-{{ question.uuid }}"
          [id]="'choice-' + answer.uuid"
          [value]="answer.uuid"
          disabled
          class="appearance-none h-5 w-5 border-2 border-blue-300 rounded-full checked:bg-blue-500 checked:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all cursor-pointer"
        />
      </div>
      <label [for]="'choice-' + answer.uuid" class="ml-3 cursor-pointer select-none">{{
        answer.answer
      }}</label>
    </div>
  </div>
</div>
